import React from 'react'
import useSWR from 'swr'
import Fetcher from 'lib/fetcher'
import DropDown from 'lib/drop-down'
import InputField from 'lib/input'
import Fetch from 'lib/fetch'
import Button from 'lib/button'
import { CheckBadgeIcon } from '@heroicons/react/24/outline'
import CheckboxField from 'lib/checkbox'

const NodeSelect = ({ model }) => {
  const { data: environments } = useSWR('environments', Fetcher)
  const { data: tenants } = useSWR(
    model.environment ? `/environments/${model.environment.id}/tenants` : null,
    Fetcher
  )
  const { data: nodes } = useSWR(
    model.tenant
      ? `/environments/${model.environment.id}/tenants/${model.tenant.id}/nodes`
      : null,
    Fetcher
  )

  const updateToken = () => {
    Fetch(`/environments/${model.environment.id}`, {
      method: 'PATCH',
      body: JSON.stringify({
        environment: {
          token: model.updatedToken,
        },
      }),
    }).then((response) => {
      if (response.ok) {
        response.json().then((body) => (model.environment = body))
      } else {
        response
          .json()
          .then((body) => alert('An error occurred ' + body.errors))
      }
    })
  }

  return (
    <div className="flex flex-col space-y-2">
      <DropDown
        options={environments}
        label="Select the Management Plane"
        onChange={(newEnv) => {
          model.environment = environments.find((env) => env.id === newEnv)
          model.tenant = null
          model.node = null
        }}
        value={model.environment}
        placeholder="No management plane selected"
      />
      {model.environment &&
        (model.environment.token_valid ? (
          <div className="flex items-center space-x-1 text-xs">
            <CheckBadgeIcon className="text-green-500 w-4 h-4" />
            <span>Token for {model.environment.label} is valid</span>
          </div>
        ) : (
          <div className="text-red-500 text-xs flex flex-col space-y-1">
            <div>
              The token for this management plane is invalid - an updated token
              needs to be provided below
            </div>
            <div className="flex flex-row items-center space-x-2">
              <InputField
                value={model.updatedToken}
                onChange={(newToken) => (model.updatedToken = newToken)}
              />
              <Button
                label="Update Token"
                onClick={updateToken}
                disabled={!model.updatedToken}
              />
            </div>
          </div>
        ))}
      {model.environment?.token_valid && (
        <DropDown
          options={tenants}
          label="Select the Tenant"
          onChange={(newTenant) => {
            model.tenant = tenants.find((tenant) => tenant.id === newTenant)
            model.node = null
          }}
          value={model.tenant}
          placeholder="No tenant selected"
        />
      )}
      {model.tenant && (
        <DropDown
          options={nodes}
          label="Select the Node"
          onChange={(newNode) => {
            model.node = nodes.find((tenant) => tenant.id === newNode)
          }}
          value={model.node}
          placeholder="No tenant selected"
        />
      )}
      {model.node && (
        <div className="flex flex-col space-y-1 pl-1">
          <CheckboxField
            value={model.baseline}
            onChange={(e) => (model.baseline = e.target.checked)}
            label="Allow user(s) to baseline node"
          />
          <CheckboxField
            value={model.operational_state}
            onChange={(e) => (model.operational_state = e.target.checked)}
            label="Allow user(s) to change operational state of node"
          />
        </div>
      )}
    </div>
  )
}

export default NodeSelect
